<template>
<ul>
    <template v-for="(item, index) in navItems">
        <template v-if="item.children">
            <!-- First level dropdown -->
            <li v-bind:key="index" class="have-submenu">
            <a href="#"><span>{{$t(item.name)}}</span> <i style="font-size:10px;" class="fas fa-chevron-down"></i></a>
            <ul class="submenu-mobile">
                <template v-for="(childL1, index) in item.children">
                <li v-bind:key="index">
                    <router-link  :to="{name: childL1.url}" @click.native="close">
                    <i :class="childL1.icon"></i> <span>{{$t(childL1.name)}}</span>
                    </router-link>
                </li>
                </template>
            </ul>
            </li>
        </template>
        <template v-else>
            <li v-bind:key="index">
            <router-link :to="{name: item.url}" @click.native="close">
            <i :class="item.icon"></i> <span>{{$t(item.name)}}</span>
            </router-link>
            </li>
        </template>
    </template>
    <hr>
    <template v-for="(item, index) in navSideItems">
        <li>
        <router-link  :to="{name: item.url}" @click.native="close">
            <i :class="item.icon"></i> <span>{{$t(item.name)}}</span>
        </router-link>
        </li>
    </template>
</ul>
</template>
      
<script>

export default {
  name: 'head-side-menu',
  data:() => ( {
        navItems: [],
        navSideItems: [],
        customer: {}
  }),
  components: {
      
  },
  mounted() {
        this.navItems = this.$store.getters.getMenu;
        this.navSideItems = this.$store.getters.getSideMenu;
        this.customer = this.$store.getters.getCustomer;
  },
  methods: {

            logout: function () {
                this.$store.dispatch('account/logout')
                    .then(() => {});
            },
            close() {
                this.$emit('closeMobileMenu');
            }
  },

}
</script>

<style lang="css">

</style>
